// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"892ff5c6","453":"dd7c5c21","455":"a99c2438","977":"5e7bfd62"}[chunkId] + ".chunk.js";
};